/**
 * Where people get help (M39, docs/adr/0057-pilot-readiness.md): the
 * support desk's contact, as set for the deployment. Public, so the sign-in
 * page has it too; any part may be unset.
 */
import { useQuery } from "@tanstack/react-query";

import { api, type Schemas, unwrap } from "./client";

export type HelpContact = Schemas["HelpContact"];

export function useHelpContact() {
  return useQuery({
    queryKey: ["help-contact"],
    queryFn: async () => unwrap(await api.GET("/api/v1/reference/help")),
    // Set when the deployment starts; it doesn't change under a page.
    staleTime: Infinity,
    retry: false,
  });
}

/** Whether there is a way to reach the help desk at all. */
export function reachable(contact: HelpContact | undefined): contact is HelpContact {
  return Boolean(contact && (contact.email || contact.phone || contact.url));
}

/** A phone number as a tel: link wants it: digits and a leading +. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, "")}`;
}
